package com.htmlagent.site.components.widgets

import androidx.compose.runtime.Composable
import com.htmlagent.site.theme.MarkImageStyle
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Img

/** The one painting of the mark. `resources/public` is served from the root of the site. */
private const val MARK = "/logo-mark.svg"

/**
 * The product mark, painted once and used in both color modes.
 *
 * It is an `<img>` and not a mask over `currentColor` the way the icons are: it carries three
 * tones -face, line and the accent of the glasses- and a mask would flatten all three into one.
 *
 * There used to be two files, one per color mode, because an `<img>` is its own document and
 * cannot read the tokens of the page that shows it. One is enough now that the figure is defined
 * by its outline instead of by the tile showing through it: line and glasses hold 17.40:1 and
 * 5.39:1 against the face in either mode, so only the tile behind it has to follow the mode.
 *
 * It sizes itself as a share of the tile that holds it, so it follows whichever token gave that
 * tile its size. The `alt` is empty on purpose: every place that shows it also writes the
 * product name, and a second reading of the same name is noise for a screen reader.
 */
@Composable
fun Mark() {
    Img(src = MARK, alt = "", attrs = MarkImageStyle.toModifier().toAttrs())
}
